import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { TemplatesManager } from "../../../library-js/templates/TemplatesManager";
import { InspectorField } from "../fields/InspectorField";

export class InspectorContainer
{
  static readonly type              = new ElementType( "inspector--container" );
  static readonly containerName     = new ElementType( "container--name" );
  static readonly containerValue    = new ElementType( "container--value" );
  static readonly containerChildren = new ElementType( "container--children" );
  static readonly containerOpener   = new ElementType( "container--opener" );

  static create( name:string, templateManager:TemplatesManager, valueElement:Element )
  {
    let element = templateManager.createTemplate( InspectorContainer.type.selector );

    let nameElement = InspectorContainer.containerName.query( element );
    HTMLEditor.setText( nameElement, name );

    InspectorContainer.containerValue.query( element ).appendChild( valueElement );

    let opener = InspectorContainer.containerOpener.query( element );
    HTMLEditor.setText( opener, InspectorField.closeText );

    return element;
  }

}